import { render, staticRenderFns } from "./followBrand.vue?vue&type=template&id=49b00e30&"
import script from "./followBrand.vue?vue&type=script&lang=js&"
export * from "./followBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports